export default "__VITE_ASSET__1f601fd1__"